export const STRIPE_API_NAME = 'stripeapi';
export const CASENOTER_BUILD_WIN_X64 = 'Casenoter-x64.exe';
export const CASENOTER_BUILD_WIN_X86 = 'Casenoter-x86.exe';
export const CASENOTER_BUILD_MAC = 'Casenoter_MAC.dmg';
export const DOWNLOAD_PAGE_URL = 'https://www.casenoter.com/download';
